
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body = $( 'body' );
		let headerHeight = $( 'header' ).height();

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Header Body Padding
		 */
		if ($(window).scrollTop() > 100) {
			$('body header').addClass('sticked').css('position', 'fixed');
			$('#content').css('padding-top', headerHeight);
		} else {
			$('body header').removeClass('sticked').css('position', 'sticky');
			$('#content').css('padding-top', 0);
		}
		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$('body header').addClass('sticked').css('position', 'fixed');
				$('#content').css('padding-top', headerHeight);
			} else {
				$('body header').removeClass('sticked').css('position', 'sticky');
				$('#content').css('padding-top', 0);
			}
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100){
			body.addClass('sticky-header');
			$('header').addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			$('header').removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 100){
				$('body').addClass('sticky-header');
				$('header').addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				$('header').removeClass('sticky');
			}
		});

	});
})(jQuery);